import state from './state'

export default {
    getCurrencies:      () => state.currencies || [],
    browsingCurrency:   () => state.browsingCurrency || [],
}